import { ca } from "../../../../date-fns/locale/ca.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ca
  }
};